import { styled } from '@mui/material';

export const ConfirmationCodeDigitInput = styled('input')(({ theme }) => ({
  width: '52px',
  height: '52px',
  textAlign: 'center',
  fontSize: '1.2rem',
  borderRadius: '4px',
  background: theme.palette.background.default,
  '&:focus': {
    outline: 'none',
    borderColor: theme.palette.primary.main,
  },
}));